customElements.get('countdown-timer') ||
  customElements.define(
    'countdown-timer',
    class extends HTMLElement {
      constructor() {
        super();
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                this.init();
              }
            });
          },
          {
            rootMargin: '150px 0px',
            threshold: 0,
          },
        );

        const targetSection = this.closest('section') || this.closest('.shopify-section');
        if (targetSection) {
          observer.observe(targetSection);
        }
      }

      init() {
        this.MS_IN_SECOND = 1000;
        this.MS_IN_MINUTE = 60 * this.MS_IN_SECOND;
        this.MS_IN_HOUR = 60 * this.MS_IN_MINUTE;
        this.MS_IN_DAY = 24 * this.MS_IN_HOUR;

        this.selectorMapping = {
          day: '[data-timer-day]',
          hour: '[data-timer-hour]',
          minute: '[data-timer-minute]',
          second: '[data-timer-second]',
        };

        this.units = ['day', 'hour', 'minute', 'second'];
        this.type = this.dataset.type;
        this.duration = this.dataset.duration;
        this.loop = false;
        this.shouldAddLeadingZero = true;

        this.initCountdown();
      }

      initCountdown() {
        if (this.type === 'fixed_time') {
          const dueDate = this.dataset.dueDate;
          if (dueDate) {
            this.targetTime = new Date(dueDate).getTime();
          }
        } else {
          this.targetTime = this.getEvergreenDueDate().getTime();
        }

        if (this.targetTime) {
          this.startTime = Date.now();
          if (this.targetTime > this.startTime) {
            this.fetchDomElements();
            this.beginCountdown();
          } else {
            if (this.dataset.type === 'fixed_time' && this.querySelector('[data-countdown-expired-text]')) {
              this.classList.remove('hidden');
              this.querySelector('[data-countdown-timer-inner]').classList.add('hidden');
              this.querySelector('[data-countdown-expired-text]').classList.remove('hidden');
            }
          }
        }
      }

      fetchDomElements() {
        this.elements = {};
        this.units.forEach((unit) => {
          this.elements[unit] = this.querySelector(this.selectorMapping[unit]);
        });
      }

      beginCountdown() {
        this.intervalId = setInterval(() => {
          const remainingTime = this.targetTime - Date.now();
          if (remainingTime <= 0) {
            this.terminateCountdown();
          } else {
            this.updateDisplay(remainingTime);
          }
        }, 1000);

        this.classList.remove('hidden');
      }

      updateDisplay(remainingTime) {
        const timeComponents = this.computeTimeComponents(remainingTime);
        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent = this.formatTimeComponent(timeComponents[unit]);
          }
        });
      }

      computeTimeComponents(ms) {
        return {
          day: Math.floor(ms / this.MS_IN_DAY),
          hour: Math.floor((ms % this.MS_IN_DAY) / this.MS_IN_HOUR),
          minute: Math.floor((ms % this.MS_IN_HOUR) / this.MS_IN_MINUTE),
          second: Math.floor((ms % this.MS_IN_MINUTE) / this.MS_IN_SECOND),
        };
      }

      formatTimeComponent(value) {
        return this.shouldAddLeadingZero && value < 10 ? `0${value}` : value.toString();
      }

      terminateCountdown() {
        clearInterval(this.intervalId);
        if (this.loop) {
          this.beginCountdown();
        } else {
          if (this.dataset.type === 'fixed_time' && this.querySelector('[data-countdown-expired-text]')) {

            this.classList.remove('hidden');
            this.querySelector('[data-countdown-timer-inner]').classList.add('hidden');
            this.querySelector('[data-countdown-expired-text]').classList.remove('hidden');
            return;
          }

          this.classList.add('hidden');
        }
      }

      resetCountdown() {
        clearInterval(this.intervalId);
        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent = '00';
          }
        });
      }

      getEvergreenDueDate() {
        const now = new Date();
        const dueDate = new Date(now);
        let intervalHours;

        switch (this.duration) {
          case 'every_month':
            dueDate.setMonth(dueDate.getMonth() + 1);
            dueDate.setDate(1);
            dueDate.setHours(0, 0, 0, 0);
            return dueDate;
          case 'every_week':
            const daysUntilNextWeek = 7 - now.getDay();
            dueDate.setDate(now.getDate() + daysUntilNextWeek);
            dueDate.setHours(0, 0, 0, 0);
            return dueDate;
          case 'every_2_hrs':
            intervalHours = 2;
            break;
          case 'every_6_hrs':
            intervalHours = 6;
            break;
          case 'every_12_hrs':
            intervalHours = 12;
            break;
          case 'every_24_hrs':
            intervalHours = 24;
            break;
          default:
            return dueDate;
        }

        const currentHour = now.getHours();
        const startPoints = [];
        for (let i = 0; i < 24; i += intervalHours) {
          startPoints.push(i);
        }

        for (let i = 0; i < startPoints.length; i++) {
          const point = startPoints[i];
          if (currentHour < point || (currentHour === point && now.getMinutes() === 0 && now.getSeconds() === 0)) {
            dueDate.setHours(point, 0, 0, 0);
            return dueDate;
          }
        }

        dueDate.setDate(dueDate.getDate() + 1);
        dueDate.setHours(startPoints[0], 0, 0, 0);
        return dueDate;
      }
    },
  );
